import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/techblitz-logo.png" alt="TechBlit" className="footer-logo-image" />
              <h3>TechBlit x iBUILD</h3>
              <p>Building the future of African innovation, one founder at a time.</p>
            </div>
           
          </div>
          
          <div className="footer-section">
            <h4>Event</h4>
            <ul>
              <li><a href="#about">About iBUILD</a></li>
              <li><a href="#expect">What to Expect</a></li>
              <li><a href="#event-details">Event Details</a></li>
              <li><a href="#registration">Register</a></li>
            </ul>
          </div>
          
          
          
          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><a href="mailto:ibuild@techblit.com">ibuild@techblit.com</a></li>
              <li><a href="tel:+2348118633277">+234 811 863 3277</a></li>
              <li><a href="https://www.google.com/maps/place/Gold+Rush+Suites" target="_blank" rel="noopener noreferrer">Gold Rush Suites, Port Harcourt</a></li>
 
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 TechBlit. All rights reserved.</p>
            <div className="footer-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
